export default "__VITE_ASSET__8c00b6f1__"